import { render, staticRenderFns } from "./ManualFinishGame.vue?vue&type=template&id=2e13a499&scoped=true"
import script from "./ManualFinishGame.vue?vue&type=script&lang=js"
export * from "./ManualFinishGame.vue?vue&type=script&lang=js"
import style0 from "./ManualFinishGame.vue?vue&type=style&index=0&id=2e13a499&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e13a499",
  null
  
)

export default component.exports